export function contracttoBuyandSellCommercial2026() {
return [   // Release 2025-12-30 12:21:47
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton PropertyType with No Residences", 
   isText: false,
   type: "checkbox",
   top: 225.68,
   left: 224.76,
   width: 11.28,
   height: 11.28
}
,
{
   page: 0,
   name: "Radiobutton PropertyType with ResidencesResidential Addendum Attached", 
   isText: false,
   type: "checkbox",
   top: 241.76,
   left: 149.4,
   width: 11.28,
   height: 11.28
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 264.495,
   left: 460.92,
   width: 109.92,
   height: 14.440
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 357.2,
   left: 114.0,
   width: 420.0,
   height: 14.44
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 389.64,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 403.8,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 417.72,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 414.48,
   left: 110.52,
   width: 450.00,
   height: 13.08
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 448.64,
   left: 112.32,
   width: 420.00,
   height: 14.44
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 478.88,
   left: 425.04,
   width: 140.04,
   height: 14.44
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 508.584,
   left: 38.6184,
   width: 554.5116,
   height: 181.055
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 690.28,
   left: 121.08,
   width: 439.92,
   height: 14.44
}
,
{
   page: 1,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 126.825,
   left: 201.2,
   width: 64.265,
   height: 12.120
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 155.4,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 155.4,
   left: 143.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 155.4,
   left: 242.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 155.4,
   left: 338.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 263.365,
   left: 60.8729,
   width: 521.1291,
   height: 168.620
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 464.657,
   left: 58.2548,
   width: 523.7472,
   height: 137.855
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 604.56,
   left: 93.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 604.56,
   left: 138.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 681.36,
   left: 66.0,
   width: 495.0,
   height: 12.12
}
,
{
   page: 1,
   name: "Storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 708.0,
   left: 66.0,
   width: 495.0,
   height: 12.12
}
,
{
   page: 2,
   name: "Trade Fixtures", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 67.728,
   left: 60.2184,
   width: 512.6196,
   height: 134.582
}
,
{
   page: 2,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.783,
   left: 59.5639,
   width: 510.0021,
   height: 137.200
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 402.6,
   left: 98.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 402.6,
   left: 143.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 446.52,
   left: 99,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 472.68,
   left: 375.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 472.68,
   left: 420.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 526.911,
   left: 51.7093,
   width: 524.4017,
   height: 118.873
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 660.6,
   left: 103.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 671.567,
   left: 62.1821,
   width: 513.9289,
   height: 57.3452
}
,
{
   page: 2,
   name: "Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 728.3237,
   left: 337.32,
   width: 165.00,
   height: 12.4363
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 56.76,
   left: 103.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Other Rights Relating to Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 81.164,
   left: 61.5275,
   width: 510.0025,
   height: 75.018
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 156.6,
   left: 103.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 233.28,
   left: 151.8,
   width: 315.0,
   height: 12.36
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 253.08,
   left: 103.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.783,
   left: 61.5275,
   width: 511.3115,
   height: 64.546
}
,
{
   page: 3,
   name: "Time of Day Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 463.389,
   left: 388.56,
   width: 181.48,
   height: 11.640
}
,
{
   page: 3,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 476.109,
   left: 329.0,
   width: 56.24,
   height: 11.400
}
,
{
   page: 3,
   name: "Alternative Earnest Money Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 476.109,
   left: 388.56,
   width: 181.48,
   height: 11.400
}
,
{
   page: 3,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 499.389,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Record Title Deadline and Tax Certificate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.389,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 512.589,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Record Title Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 512.589,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 525.789,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "OffRecord Title Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 525.789,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 538.989,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "OffRecord Title Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 538.989,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 552.314,
   left: 329.0,
   width: 56.24,
   height: 11.880
}
,
{
   page: 3,
   name: "Title Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 552.314,
   left: 388.56,
   width: 181.48,
   height: 11.880
}
,
{
   page: 3,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 565.274,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 565.274,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 588.849,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Association Documents", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 589.038,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 602.049,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Association Documents Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 602.238,
   left: 388.56,
   width: 181.48,
   height: 12.120
}
,
{
   page: 3,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 627.161,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "Sellers Property Disclose", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 627.35,
   left: 388.56,
   width: 181.48,
   height: 12.12
}
,
{
   page: 3,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 641.361,
   left: 329.0,
   width: 56.24,
   height: 11.880
}
,
{
   page: 3,
   name: "LeadBased Paint Disclosure", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 640.55,
   left: 388.56,
   width: 181.48,
   height: 11.88
}
,
{
   page: 3,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 674.361,
   left: 329.0,
   width: 56.24,
   height: 12.120
}
,
{
   page: 3,
   name: "New Loan Application", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 674.55,
   left: 388.56,
   width: 181.48,
   height: 12.12
}
,
{
   page: 3,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 687.561,
   left: 329.0,
   width: 56.24,
   height: 12.1202
}
,
{
   page: 3,
   name: "New Loan Terms", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 687.75,
   left: 388.56,
   width: 181.48,
   height: 12.1202
}
,
{
   page: 3,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 700.7612,
   left: 329.0,
   width: 56.24,
   height: 12.1200
}
,
{
   page: 3,
   name: "New Loan Availability", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 700.9502,
   left: 388.56,
   width: 181.48,
   height: 12.1200
}
,
{
   page: 3,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 713.9612,
   left: 329.0,
   width: 56.24,
   height: 11.8800
}
,
{
   page: 3,
   name: "Buyers Credit Information", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 714.1502,
   left: 388.56,
   width: 181.48,
   height: 11.8800
}
,
{
   page: 3,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 726.1764,
   left: 329.0,
   width: 56.24,
   height: 12.1200
}
,
{
   page: 3,
   name: "Disapproval of Buyers Credit Information", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 726.3654,
   left: 388.56,
   width: 181.48,
   height: 12.1200
}
,
{
   page: 4,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 57.817,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Existing Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 57.817,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 71.017,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Existing Loan Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 71.017,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 84.217,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Loan Transfer Approval", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 84.217,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 97.417,
   left: 328.982,
   width: 56.239,
   height: 10.880
}
,
{
   page: 4,
   name: "Seller or Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 97.417,
   left: 389.105,
   width: 180.240,
   height: 10.880
}
,
{
   page: 4,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 121.417,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Appraisal Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 121.417,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 134.617,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Appraisal Objection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 134.617,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 147.817,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "Appraisal Resolution", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 147.817,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 172.977,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "New ILC or New Survey", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 172.977,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 186.177,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "New ILC or New Survey Objection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 186.177,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 199.377,
   left: 328.982,
   width: 56.239,
   height: 11.120
}
,
{
   page: 4,
   name: "New ILC or New Survey Resolution", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 199.377,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 225.789,
   left: 328.547,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Water Rights Examination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 225.978,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 238.989,
   left: 328.547,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Mineral Rights Examination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 240.178,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 252.628,
   left: 329.091,
   width: 56.240,
   height: 10.880
}
,
{
   page: 4,
   name: "Inspection Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 252.817,
   left: 389.105,
   width: 180.240,
   height: 10.880
}
,
{
   page: 4,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 265.588,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Inspection Objection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 265.777,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 278.788,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Inspection Resolution", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 278.977,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 291.988,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Property Insurance Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 293.177,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 305.188,
   left: 329.091,
   width: 56.240,
   height: 10.880
}
,
{
   page: 4,
   name: "Due Diligence Documents Delivery", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 305.377,
   left: 389.105,
   width: 180.240,
   height: 10.880
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 318.148,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Due Diligence Documents Objection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 318.337,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 331.348,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Due Diligence Documents Resolution", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 331.537,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateEnvironmental Inspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 344.548,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "Environmental Inspection Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.737,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateADA Evaluation Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 357.748,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "ADA Evaluation Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 357.937,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 370.948,
   left: 329.091,
   width: 56.240,
   height: 10.880
}
,
{
   page: 4,
   name: "Conditional Sale", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 371.137,
   left: 389.105,
   width: 180.240,
   height: 10.880
}
,
{
   page: 4,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 383.908,
   left: 329.091,
   width: 56.240,
   height: 11.120
}
,
{
   page: 4,
   name: "LeadBased Paint Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 384.097,
   left: 389.105,
   width: 180.240,
   height: 11.120
}
,
{
   page: 4,
   name: "DateEstoppel Statements Deadline", 
   fontSize: 9,
   type: "date",
   top: 405.108,
   left: 329.091,
   width: 56.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Estoppel Statements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 405.297,
   left: 389.105,
   width: 180.240,
   height: 12.120
}
,
{
   page: 4,
   name: "DateEstoppel Statements Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 418.308,
   left: 329.091,
   width: 56.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Estoppel Statements Termination", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 418.497,
   left: 389.105,
   width: 180.240,
   height: 12.120
}
,
{
   page: 4,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 443.445,
   left: 328.504,
   width: 56.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Closing Date Details", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.243,
   left: 388.105,
   width: 181.240,
   height: 12.120
}
,
{
   page: 4,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 456.645,
   left: 328.504,
   width: 56.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Possession Date Details", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 457.443,
   left: 388.105,
   width: 181.240,
   height: 12.120
}
,
{
   page: 4,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 482.805,
   left: 328.504,
   width: 56.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Possession Time Details", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 470.643,
   left: 388.105,
   width: 181.240,
   height: 11.880
}
,
{
   page: 4,
   name: "Acceptance Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 483.656,
   left: 388.105,
   width: 181.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Acceptance Deadline Time Details", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.803,
   left: 388.105,
   width: 181.240,
   height: 12.120
}
,
{
   page: 4,
   name: "Deadlines Extra Row 1 Item", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.52,
   left: 51.96,
   width: 18.84,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 1 Ref", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.52,
   left: 71.88,
   width: 34.92,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 1 Title", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.52,
   left: 107.88,
   width: 219.48,
   height: 11.04
}
,
{
   page: 4,
   name: "Date Deadlines Extra Row 1", 
   fontSize: 9,
   type: "date",
   top: 509.52,
   left: 328.44,
   width: 57.48,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 509.52,
   left: 387,
   width: 183.72,
   height: 11.04
}
,
{
   page: 4,
   name: "Extra Row 2 Item", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 521.52,
   left: 51.96,
   width: 18.84,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 2 Ref", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 521.52,
   left: 71.88,
   width: 34.92,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 2 Title", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 521.52,
   left: 107.88,
   width: 219.48,
   height: 11.04
}
,
{
   page: 4,
   name: "Date Deadlines Extra Row 2", 
   fontSize: 9,
   type: "date",
   top: 521.52,
   left: 328.44,
   width: 57.48,
   height: 11.04
}
,
{
   page: 4,
   name: "Deadlines Extra Row 2X", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 521.52,
   left: 387,
   width: 183.72,
   height: 11.04
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 69.96,
   left: 107.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 69.96,
   left: 150.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 145.8,
   left: 312.24,
   width: 100.12,
   height: 12.8
}
,
{
   page: 5,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 160.68,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 175.8,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount Assumption Balance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 190.68,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 205.56,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 220.44,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Price Extra Row 7 Ref", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 235.44,
   left: 130.44,
   width: 53.16,
   height: 16.56
}
,
{
   page: 5,
   name: "Price Extra Row 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 235.44,
   left: 185.16,
   width: 115.08,
   height: 16.56
}
,
{
   page: 5,
   name: "Amount Item 7 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 235.44,
   left: 312.24,
   width: 100.12,
   height: 12.80
}
,
{
   page: 5,
   name: "Amount Item 7 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 235.44,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Price Extra Row 8 Ref", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 253.2,
   left: 130.44,
   width: 53.16,
   height: 16.56
}
,
{
   page: 5,
   name: "Price Extra Row 8 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 253.2,
   left: 185.16,
   width: 115.08,
   height: 16.56
}
,
{
   page: 5,
   name: "Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 254.476,
   left: 312.24,
   width: 100.12,
   height: 12.800
}
,
{
   page: 5,
   name: "Amount Item 8 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 253.2,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 271.495,
   left: 424.68,
   width: 91.24,
   height: 13.039
}
,
{
   page: 5,
   name: "CALCULATE Amount Purchase Price PLUS Amount Item 7 Debit PLUS Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 285.72,
   left: 312.24,
   width: 100.12,
   height: 12.80
}
,
{
   page: 5,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Item 7 Credit PLUS Amount Item 8 Credit PLUS Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 285.72,
   left: 424.68,
   width: 91.24,
   height: 13.04
}
,
{
   page: 5,
   name: "Amount Seller Concession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 319.44,
   left: 322.56,
   width: 140.04,
   height: 12.36
}
,
{
   page: 5,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 402.72,
   left: 394.56,
   width: 169.92,
   height: 12.36
}
,
{
   page: 5,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 415.92,
   left: 189,
   width: 270,
   height: 12.36
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 157.32,
   left: 413.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 157.32,
   left: 458.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 297.48,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 297.48,
   left: 150.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 294.48,
   left: 196.8,
   width: 345.0,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption At", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 331.92,
   left: 290.4,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Assumption Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 331.92,
   left: 380.64,
   width: 135.00,
   height: 12.84
}
,
{
   page: 6,
   name: "Assumption Rate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 345.84,
   left: 244.8,
   width: 50.04,
   height: 12.84
}
,
{
   page: 6,
   name: "Checkbox AssumptionEscrow Real Estate Taxes", 
   isText: false,
   type: "checkbox",
   top: 376.44,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox AssumptionEscrow Property Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 376.44,
   left: 166.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox AssumptionEscrow Other", 
   isText: false,
   type: "checkbox",
   top: 376.44,
   left: 336.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "AssumptionEscrow Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 373.44,
   left: 349.56,
   width: 215.04,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Loan Transfer Fee Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 387.12,
   left: 300.36,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Loan Interest Rate Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 401.04,
   left: 129.6,
   width: 45.0,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption New Payment Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 401.04,
   left: 391.8,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Assumption New Payment Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 401.04,
   left: 482.04,
   width: 84.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Cash At Closing Increase Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 442.32,
   left: 73.44,
   width: 70.08,
   height: 12.84
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will", 
   isText: false,
   type: "checkbox",
   top: 472.92,
   left: 111.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not", 
   isText: false,
   type: "checkbox",
   top: 472.92,
   left: 156.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 486.84,
   left: 289.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery At Closing", 
   isText: false,
   type: "checkbox",
   top: 486.84,
   left: 511.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Assumption Release of Liability Paid By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 511.44,
   left: 66,
   width: 174.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Release of Liability Max Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 511.44,
   left: 364.08,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 652.2,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 652.2,
   left: 116.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 650.2,
   left: 496.08,
   width: 50.04,
   height: 12.84
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 368.76,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 368.76,
   left: 114.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Seller", 
   isText: false,
   type: "checkbox",
   top: 519,
   left: 99,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Checkbox Abstract of Title", 
   isText: false,
   type: "checkbox",
   top: 556.68,
   left: 197.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Buyer", 
   isText: false,
   type: "checkbox",
   top: 586.2,
   left: 99,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will", 
   isText: false,
   type: "checkbox",
   top: 640.68,
   left: 358.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will Not", 
   isText: false,
   type: "checkbox",
   top: 640.68,
   left: 400.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Buyer", 
   isText: false,
   type: "checkbox",
   top: 720.6,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Seller", 
   isText: false,
   type: "checkbox",
   top: 720.6,
   left: 116.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Split", 
   isText: false,
   type: "checkbox",
   top: 720.6,
   left: 165.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Other", 
   isText: false,
   type: "checkbox",
   top: 720.6,
   left: 371.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "WhoPaysOEC Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 718.3638,
   left: 415.92,
   width: 144.96,
   height: 12.0762
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Seller", 
   isText: false,
   type: "checkbox",
   top: 634.68,
   left: 268.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Buyer", 
   isText: false,
   type: "checkbox",
   top: 634.68,
   left: 317.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Checkbox New ILC", 
   isText: false,
   type: "checkbox",
   top: 117.72,
   left: 85.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Checkbox New Survey", 
   isText: false,
   type: "checkbox",
   top: 132.6,
   left: 85.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "New Survey in the form of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 130.32,
   left: 213.36,
   width: 349.92,
   height: 12.12
}
,
{
   page: 12,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 166.68,
   left: 271.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 166.68,
   left: 320.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "WhoPaysNewILCorSurvey Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 221.04,
   left: 195.96,
   width: 364.92,
   height: 12.12
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysNewILCorSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 223.32,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysNewILCorSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 223.32,
   left: 135.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Delivery ILC", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 251.52,
   left: 237.36,
   width: 324.96,
   height: 12.12
}
,
{
   page: 13,
   name: "Occupancy Agreements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 566.839,
   left: 74.6185,
   width: 510.6565,
   height: 182.3644
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All contracts relating to the operation maintenance and management of the Property", 
   isText: false,
   type: "checkbox",
   top: 239.88,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Property tax bills for the last number of years", 
   isText: false,
   type: "checkbox",
   top: 257.16,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Property tax last number of years", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 254.64,
   left: 272.04,
   width: 105.00,
   height: 12.36
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem As built construction plans to the Property and the tenant improvements including architectural electrical mechanical and structural systems engineering reports permanent Certificates of Occupancy", 
   isText: false,
   type: "checkbox",
   top: 274.44,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A list of all Inclusions to be conveyed to Buyer", 
   isText: false,
   type: "checkbox",
   top: 318.12,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Operating statements for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 335.16,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Number of years Operating statements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 332.64,
   left: 290.04,
   width: 100.08,
   height: 12.36
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A rent roll accurate and correct to the date of this Contract", 
   isText: false,
   type: "checkbox",
   top: 352.44,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A schedule of any tenant improvement work Seller is obligated to complete but has not yet completed", 
   isText: false,
   type: "checkbox",
   top: 369.72,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All insurance policies pertaining to the Property and copies of any claims which have been made for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 400.2,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Number of years Insurance policies", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 410.88,
   left: 140.76,
   width: 109.92,
   height: 12.36
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Soils reports surveys and engineering reports or data pertaining to the Property if not delivered earlier", 
   isText: false,
   type: "checkbox",
   top: 430.68,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Any and all existing documentation and reports regarding Phase I and II environmental reports", 
   isText: false,
   type: "checkbox",
   top: 461.16,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Any Americans with Disabilities Act reports studies or surveys concerning the compliance of the Property with said Act", 
   isText: false,
   type: "checkbox",
   top: 531.24,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All permits licenses and other building or use authorizations issued by any governmental authority", 
   isText: false,
   type: "checkbox",
   top: 561.72,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Other Documents", 
   isText: false,
   type: "checkbox",
   top: 605.16,
   left: 139.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Documents Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 615.93,
   left: 83.1276,
   width: 484.4744,
   height: 87.4548
}
,
{
   page: 15,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Seller", 
   isText: false,
   type: "checkbox",
   top: 334.2,
   left: 242.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Buyer", 
   isText: false,
   type: "checkbox",
   top: 334.2,
   left: 290.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Due Diligence Environmental Extra", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 358.32,
   left: 231,
   width: 334.92,
   height: 12.36
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysEnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 374.04,
   left: 141.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysEnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 374.04,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "DueDiligenceEnvironmental Extend Environmental Inspection Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 402,
   left: 357.6,
   width: 95.04,
   height: 12.36
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 444.12,
   left: 69,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 444.12,
   left: 117.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Conditional On Sale Of Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 614.93,
   left: 66.7639,
   width: 479.8921,
   height: 12.182
}
,
{
   page: 16,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are", 
   isText: false,
   type: "checkbox",
   top: 587.16,
   left: 408.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are Not", 
   isText: false,
   type: "checkbox",
   top: 587.16,
   left: 448.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 652.32,
   left: 63.12,
   width: 309.96,
   height: 11.88
}
,
{
   page: 17,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 84.36,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 84.36,
   left: 225,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 84.36,
   left: 337.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 84.36,
   left: 448.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 98.04,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton DeedType Other", 
   isText: false,
   type: "checkbox",
   top: 98.04,
   left: 225.0,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 96.24,
   left: 240.84,
   width: 200.04,
   height: 11.64
}
,
{
   page: 17,
   name: "Radiobutton ClosingServicesFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 312.12,
   left: 189,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingServicesFee Seller", 
   isText: false,
   type: "checkbox",
   top: 312.12,
   left: 239.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingServicesFee Split", 
   isText: false,
   type: "checkbox",
   top: 312.12,
   left: 287.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingServicesFee Other", 
   isText: false,
   type: "checkbox",
   top: 327,
   left: 225,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "ClosingServicesFee Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 325.2,
   left: 268.92,
   width: 294.96,
   height: 11.64
}
,
{
   page: 17,
   name: "Radiobutton RecordChangeFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton RecordChangeFee Seller", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton RecordChangeFee Split", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton RecordChangeFee NA", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ReservesOrWorkingCapital Buyer", 
   isText: false,
   type: "checkbox",
   top: 470.28,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ReservesOrWorkingCapital Seller", 
   isText: false,
   type: "checkbox",
   top: 470.28,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ReservesOrWorkingCapital Split", 
   isText: false,
   type: "checkbox",
   top: 470.28,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ReservesOrWorkingCapital NA", 
   isText: false,
   type: "checkbox",
   top: 470.28,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton OtherFees Buyer", 
   isText: false,
   type: "checkbox",
   top: 502.44,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton OtherFees Seller", 
   isText: false,
   type: "checkbox",
   top: 502.44,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton OtherFees Split", 
   isText: false,
   type: "checkbox",
   top: 502.44,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton OtherFees NA", 
   isText: false,
   type: "checkbox",
   top: 502.44,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton LocalTransferTax Buyer", 
   isText: false,
   type: "checkbox",
   top: 534.6,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton LocalTransferTax Seller", 
   isText: false,
   type: "checkbox",
   top: 534.6,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton LocalTransferTax Split", 
   isText: false,
   type: "checkbox",
   top: 534.6,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton LocalTransferTax NA", 
   isText: false,
   type: "checkbox",
   top: 534.6,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton SalesAndUseTax Buyer", 
   isText: false,
   type: "checkbox",
   top: 566.52,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton SalesAndUseTax Seller", 
   isText: false,
   type: "checkbox",
   top: 566.52,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton SalesAndUseTax Split", 
   isText: false,
   type: "checkbox",
   top: 566.52,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton SalesAndUseTax NA", 
   isText: false,
   type: "checkbox",
   top: 566.52,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton PrivateTransferFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 613.56,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton PrivateTransferFee Seller", 
   isText: false,
   type: "checkbox",
   top: 613.56,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton PrivateTransferFee Split", 
   isText: false,
   type: "checkbox",
   top: 613.56,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton PrivateTransferFee NA", 
   isText: false,
   type: "checkbox",
   top: 613.56,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Amount Water Transfer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 642.48,
   left: 73.44,
   width: 95.04,
   height: 11.64
}
,
{
   page: 17,
   name: "Checkbox Water DistrictMunicipality", 
   isText: false,
   type: "checkbox",
   top: 661.08,
   left: 94.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "CheckboxAugmentation Membership", 
   isText: false,
   type: "checkbox",
   top: 677.64,
   left: 94.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "CheckboxWater Stock", 
   isText: false,
   type: "checkbox",
   top: 661.08,
   left: 243,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Checkbox Small Domestic Water Company", 
   isText: false,
   type: "checkbox",
   top: 677.64,
   left: 243,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Checkbox Water Transfer Fee Other", 
   isText: false,
   type: "checkbox",
   top: 677.64,
   left: 404.238,
   width: 10.080,
   height: 10.08
}
,
{
   page: 17,
   name: "Water Transfer Fee Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 675.84,
   left: 418.44,
   width: 144.96,
   height: 11.64
}
,
{
   page: 17,
   name: "Radiobutton WaterTransferFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton WaterTransferFee Seller", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton WaterTransferFee Split", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton WaterTransferFee NA", 
   isText: false,
   type: "checkbox",
   top: 708.12,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton UtilityTransferFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 739.56,
   left: 193.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton UtilityTransferFee Seller", 
   isText: false,
   type: "checkbox",
   top: 739.56,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton UtilityTransferFee Split", 
   isText: false,
   type: "checkbox",
   top: 739.56,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton UtilityTransferFee NA", 
   isText: false,
   type: "checkbox",
   top: 739.56,
   left: 498.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 98.76,
   left: 529.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 315.24,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 329.16,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 357.24,
   left: 66.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 355.44,
   left: 110.52,
   width: 444.96,
   height: 11.64
}
,
{
   page: 18,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 381.48,
   left: 201,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 381.48,
   left: 326.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Other Prorations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 440.16,
   left: 66,
   width: 484.92,
   height: 11.64
}
,
{
   page: 18,
   name: "Radiobutton AssociationAssessmentsObligation Buyer", 
   isText: false,
   type: "checkbox",
   top: 540.6,
   left: 125.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton AssociationAssessmentsObligation Seller", 
   isText: false,
   type: "checkbox",
   top: 540.6,
   left: 175.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 589.2,
   left: 66,
   width: 499.92,
   height: 11.64
}
,
{
   page: 18,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 681.12,
   left: 435.96,
   width: 84.96,
   height: 11.64
}
,
{
   page: 20,
   name: "Buyer will be paid to Seller and retained by Seller It is agreed that the Earnest Money is not a penalty and the parties agree", 
   isText: false,
   type: "checkbox",
   top: 65.48,
   left: 103.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 21,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 348.48,
   left: 66,
   width: 360,
   height: 11.76
}
,
{
   page: 21,
   name: "Checkbox PaysBuyerBrokerage Seller", 
   isText: false,
   type: "checkbox",
   top: 619.8,
   left: 78.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 21,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 617.68,
   left: 96.72,
   width: 35.04,
   height: 11.96
}
,
{
   page: 21,
   name: "Amount Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 617.68,
   left: 250.56,
   width: 75.00,
   height: 11.96
}
,
{
   page: 21,
   name: "Checkbox PaysBuyerBrokerage Buyer", 
   isText: false,
   type: "checkbox",
   top: 661.8,
   left: 78.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 21,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 659.68,
   left: 96.72,
   width: 35.04,
   height: 11.96
}
,
{
   page: 21,
   name: "Amount Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 659.68,
   left: 250.56,
   width: 75.00,
   height: 11.96
}
,
{
   page: 21,
   name: "Checkbox PaysBuyerBrokerage Sellers Brokerage", 
   isText: false,
   type: "checkbox",
   top: 703.8,
   left: 78.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 21,
   name: "Percent Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 701.68,
   left: 96.72,
   width: 35.04,
   height: 11.96
}
,
{
   page: 21,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 701.68,
   left: 250.56,
   width: 75.00,
   height: 11.96
}
,
{
   page: 22,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 98.182,
   left: 40.582,
   width: 543.384,
   height: 547.602
}
,
{
   page: 22,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 670.603,
   left: 50.4002,
   width: 534.2198,
   height: 79.6002
}
,
{
   page: 23,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 66.764,
   left: 50.4002,
   width: 516.5468,
   height: 52.109
}
,
{
   page: 23,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 152.329,
   left: 139.724,
   width: 435.000,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 190.369,
   left: 139.724,
   width: 435.000,
   height: 14.040
}
,
{
   page: 23,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.129,
   left: 139.724,
   width: 170.040,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.129,
   left: 452.204,
   width: 120.000,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 220.129,
   left: 139.724,
   width: 435.000,
   height: 13.800
}
,
{
   page: 23,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.569,
   left: 139.724,
   width: 435.000,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 279.816,
   left: 138.574,
   width: 435.000,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.609,
   left: 139.724,
   width: 169.385,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.609,
   left: 460.204,
   width: 120.000,
   height: 14.160
}
,
{
   page: 23,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 307.609,
   left: 139.724,
   width: 435.000,
   height: 13.800
}
,
{
   page: 23,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 328.26,
   left: 138.138,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 374.056,
   left: 137.455,
   width: 439.965,
   height: 12.837
}
,
{
   page: 23,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 442.302,
   left: 139.096,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 480.125,
   left: 140.106,
   width: 429.960,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.005,
   left: 139.451,
   width: 170.040,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.005,
   left: 452.586,
   width: 120.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 510.342,
   left: 138.274,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 538.302,
   left: 138.274,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 576.342,
   left: 138.274,
   width: 429.960,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 591.102,
   left: 138.274,
   width: 170.040,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 591.102,
   left: 450.754,
   width: 120.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 606.102,
   left: 138.274,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.062,
   left: 138.274,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 661.542,
   left: 138.274,
   width: 435.000,
   height: 13.338
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 93.301,
   left: 85.1418,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 93.301,
   left: 126.822,
   width: 10.080,
   height: 10.554
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 185.566,
   left: 53.9855,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 200.766,
   left: 54.6619,
   width: 10.0801,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 217.265,
   left: 53.7491,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 307.092,
   left: 179.461,
   width: 375.000,
   height: 12.480
}
,
{
   page: 24,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 319.4,
   left: 179.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 24,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 333.6,
   left: 179.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 24,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 346.8,
   left: 179.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 24,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 372.676,
   left: 181.624,
   width: 178.546,
   height: 13.000
}
,
{
   page: 24,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 371.469,
   left: 375.031,
   width: 78.164,
   height: 12.480
}
,
{
   page: 24,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 407.367,
   left: 180.969,
   width: 184.437,
   height: 13.000
}
,
{
   page: 24,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 408.815,
   left: 371.627,
   width: 81.949,
   height: 11.825
}
,
{
   page: 24,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 433.538,
   left: 180.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 24,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 446.738,
   left: 180.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 24,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 459.938,
   left: 180.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 24,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 473.138,
   left: 180.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 24,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 483.711,
   left: 179.346,
   width: 375.819,
   height: 14.800
}
,
{
   page: 24,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 552.743,
   left: 88.9565,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 553.397,
   left: 136.542,
   width: 10.080,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 628.978,
   left: 200.631,
   width: 10.080,
   height: 10.080
}
,
{
   page: 24,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 628.651,
   left: 287.151,
   width: 10.080,
   height: 10.407
}
,
{
   page: 24,
   name: "Radiobutton SellerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 648.543,
   left: 53.6983,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Checkbox SellerBrokerageFirmPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 689.299,
   left: 87.3856,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 24,
   name: "Checkbox SellerBrokerageFirmPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 689.299,
   left: 135.866,
   width: 10.080,
   height: 10.080
}
,
{
   page: 24,
   name: "Checkbox SellerBrokerageFirmPaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 689.299,
   left: 186.026,
   width: 10.080,
   height: 10.080
}
,
{
   page: 24,
   name: "SellerBrokerageFirmPaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 688.738,
   left: 233.609,
   width: 319.363,
   height: 10.5161
}
,
{
   page: 25,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 96.83,
   left: 180.058,
   width: 375.000,
   height: 12.48
}
,
{
   page: 25,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 110.03,
   left: 180.058,
   width: 375.000,
   height: 12.48
}
,
{
   page: 25,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 123.23,
   left: 180.058,
   width: 375.000,
   height: 12.48
}
,
{
   page: 25,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 136.43,
   left: 180.058,
   width: 375.000,
   height: 12.48
}
,
{
   page: 25,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 163.202,
   left: 179.938,
   width: 171.273,
   height: 11.476
}
,
{
   page: 25,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 213.471,
   left: 179.547,
   width: 173.367,
   height: 12.000
}
,
{
   page: 25,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 161.783,
   left: 367.323,
   width: 105.000,
   height: 12.480
}
,
{
   page: 25,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 213.099,
   left: 366.276,
   width: 95.040,
   height: 12.480
}
,
{
   page: 25,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 239.819,
   left: 179.011,
   width: 375.000,
   height: 12.480
}
,
{
   page: 25,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 253.019,
   left: 179.011,
   width: 375.000,
   height: 12.480
}
,
{
   page: 25,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 266.219,
   left: 179.011,
   width: 375.000,
   height: 12.480
}
,
{
   page: 25,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 279.419,
   left: 179.011,
   width: 375.000,
   height: 12.480
}
,
{
   page: 25,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 292.619,
   left: 179.011,
   width: 375.000,
   height: 12.480
}
] }
